module.exports = __webpack_public_path__ + "static/media/icon-unchecked.3ceac789.svg";